import {ReactNode} from 'react'

import classNames from 'classnames/bind'

import Styles from './MyAssetUnitaryLayout.module.scss'

const cx = classNames.bind(Styles)

// 2단 레이아웃 컨텐츠
export const ColumnContent = ({children}: {children: ReactNode}) => {
    return <div className={cx('content')}>{children}</div>
}

// 2단 레이아웃 사이드바
export const ColumnSnb = ({children}: {children: ReactNode}) => {
    return <div className={cx('snb')}>{children}</div>
}

interface MyAssetUnitaryLayoutProps {
    columnLayout?: boolean
    equalType?: boolean
    children: ReactNode
}

export default function MyAssetUnitaryLayout({columnLayout, equalType, children}: MyAssetUnitaryLayoutProps) {
    return <div className={cx('article', {column: columnLayout}, {'equal-type': equalType})}>{children}</div>
}
